import { ColumnsType, Progress } from '@agro-club/agroclub-shared'
import { refetchFunc } from 'modules/domain/common/hooks'
import { FC } from 'react'
import { NoData } from 'views/components/NoData/NoData'
import { ATableFullPageWithoutData } from 'views/components/Table/ATableFullPageWithoutData'
import { DashboardTabItemProps } from '../types'

export type UseDashboardColumnsProps = {
  refetch: refetchFunc
  successText: string
}

type Props = DashboardTabItemProps & {
  successText: string
  useColumns: (props: UseDashboardColumnsProps) => ColumnsType
  rowClassName?: () => string
}

export const DashboardTasksList: FC<Props> = (props) => {
  const { fetchFunc: refetch, progress, data, total, successText, useColumns, rowClassName } = props

  const columns = useColumns({ refetch, successText })

  return !data?.length && !total && (progress === Progress.SUCCESS || progress === Progress.ERROR) ? (
    <NoData />
  ) : (
    <ATableFullPageWithoutData columns={columns} {...props} rowHoverGray rowClassName={rowClassName} />
  )
}
